var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3228.408,
    height: 2757.445,
    viewBox: "0 0 3228.408 2757.445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_66688",
    "data-name": "Group 66688",
    transform: "translate(-19639.5 -15874)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66687",
    "data-name": "Group 66687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66686",
    "data-name": "Group 66686",
    transform: "translate(19634.928 15831.727)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    "data-name": "Background Simple",
    transform: "translate(80.45 42.274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66665",
    "data-name": "Group 66665",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137775",
    "data-name": "Path 137775",
    d: "M57.08,1462.427c-108.41,379.693,11.589,734.716,229.184,966.136,241.259,256.571,567.021,356.812,938.394,261.951,147.175-37.594,294.08-89.132,441.59-110.955,253.664-37.529,518.16-16.732,771.534-89.823,320.46-92.44,618.42-425.542,624.175-789.562,1.993-126.26-25.414-244.942-62.232-356.562-90.54-274.48-238.129-513.122-408.448-725.5-192-239.4-421.333-452.324-711.723-540.213C1238.831-116.033,527.181,514.41,172.98,1179.357,124.8,1269.818,84.756,1365.481,57.08,1462.427Z",
    transform: "translate(-16.533 -42.274)",
    fill: "#1c1a57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137776",
    "data-name": "Path 137776",
    d: "M57.08,1462.427c-108.41,379.693,11.589,734.716,229.184,966.136,241.259,256.571,567.021,356.812,938.394,261.951,147.175-37.594,294.08-89.132,441.59-110.955,253.664-37.529,518.16-16.732,771.534-89.823,320.46-92.44,618.42-425.542,624.175-789.562,1.993-126.26-25.414-244.942-62.232-356.562-90.54-274.48-238.129-513.122-408.448-725.5-192-239.4-421.333-452.324-711.723-540.213C1238.831-116.033,527.181,514.41,172.98,1179.357,124.8,1269.818,84.756,1365.481,57.08,1462.427Z",
    transform: "translate(-16.533 -42.274)",
    fill: "#fff",
    opacity: 0.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Floor",
    transform: "translate(5.073 2752.67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66666",
    "data-name": "Group 66666"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_15820",
    "data-name": "Line 15820",
    x2: 3194.554,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Plants",
    transform: "translate(37.804 1146.077)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66667",
    "data-name": "Group 66667",
    transform: "translate(1799.973)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137777",
    "data-name": "Path 137777",
    d: "M366.57,413.987c39.225,17.127,135.158,14.969,135.237,14.969.993-.026-20.625-62.8-22.441-66.606-21.047-44.04-87.62-116.749-141.782-109.429-39.015,5.275-60.719,44.329-51.913,81.062C294.669,371.512,333.165,399.386,366.57,413.987Z",
    transform: "translate(-283.724 25.853)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137778",
    "data-name": "Path 137778",
    d: "M392.829,927.834c40.685,5.932,126.3-18.9,133.113-20.9,13.516,47.927,31.274,96.012,51.926,143.682,11.773,27.269,24.486,54.366,37.575,81.371-7.807-11.431-14.884-21.606-16.015-22.927-31.945-36.917-115.348-89.461-165.643-68.086-36.259,15.384-46.861,58.773-28.669,91.888,18.574,33.813,63.087,50.538,99.149,55.786,36.608,5.347,110.028-14.364,129.39-19.836,5.13,10.313,10.135,20.658,15.3,30.945,24.8,49.367,49.749,98.524,72.749,147.49,8.116,17.245,15.463,34.536,22.895,51.807-6.945-10.155-12.884-18.646-13.93-19.856-31.925-36.9-115.328-89.455-165.636-68.085-36.253,15.39-46.868,58.785-28.669,91.888,18.6,33.813,63.081,50.538,99.156,55.793,34.937,5.1,102.865-12.483,125.9-18.876,7.077,17.916,14.187,35.845,20.224,53.524,3.854,12.167,8.419,23.6,11.6,36.042q5.13,18.37,10.148,36.371c5.6,23.342,11.53,47.414,16.416,70.328,3.525,15.917,6.59,31.149,9.721,46.48-7.873-17.265-24.006-50.742-25.677-53.392-25.96-41.324-100.445-105.884-153.416-92.395-38.154,9.728-55.221,51.005-42.238,86.488,13.246,36.233,54.681,59.509,89.54,70.171,38.39,11.727,123.366,1.013,133.975-.4,5.1,25.387,9.806,50.137,13.878,73.558q4.587,26.006,8.4,50.005h34.036q-4.824-26.736-10.6-55.958c-5.064-25.8-11-53.268-17.35-81.424,6.386-2.539,42.633-17.2,74.748-35.148,27.972,30.294,99.656,65.751,108.936,70.263-9.754,23.987-19.475,47.223-29,69.006-5.018,11.549-9.892,22.434-14.746,33.26h35.99c2.861-6.847,5.683-13.542,8.6-20.658,10.01-24.315,20.224-50.512,30.452-77.491,10.28,2.151,94.4,19.238,133.606,10.392,35.556-8.044,78.629-28.156,94.545-63.311,15.588-34.411,1.638-76.853-35.707-89.4-51.8-17.4-130.89,41.435-159.862,80.714-1.717,2.315-17.455,29.524-27.1,46.855,4.117-11.049,8.241-21.73,12.345-33.162,8.281-22.533,15.857-45.27,24.112-69.7q5.357-17.906,10.826-36.174c3.861-12,6.426-25.17,9.734-37.857,7.051-29.59,12.74-59.91,17.811-90.579,19.751,7.182,90.263,31.721,126.8,29.149,36.365-2.558,81.976-15.91,103.029-48.249,20.619-31.655,13.266-75.728-21.73-93.782-48.584-25.052-135.671,21.139-170.267,55.569-2.157,2.138-24.2,29.643-36.016,44.974,2.9-18.462,5.887-36.871,8.215-55.648,6.728-54.195,11.845-109.258,17.2-164.17,1.631-16.824,3.459-33.562,5.229-50.328,7,2.637,90.178,33.609,131.1,30.735,36.365-2.545,81.983-15.91,103.036-48.256,20.619-31.649,13.259-75.715-21.737-93.762-48.578-25.052-135.658,21.125-170.253,55.556-2.6,2.591-34.273,42.2-41.83,52.676,3.9-36.93,8.129-73.683,13.772-109.751,7.708-49.768,18.041-98.182,31.5-144.346,3.256,1.236,89.935,33.951,131.837,31.011,36.365-2.559,81.99-15.917,103.036-48.249,20.619-31.655,13.266-75.722-21.73-93.776-48.585-25.052-135.665,21.132-170.267,55.556-2.7,2.71-36.753,45.336-42.376,53.511.809-2.743,1.342-5.676,2.184-8.4,15-49.1,35.707-94.775,57.181-136.592,12.431-24.322,25.677-46.875,39.048-68.533,15.522,7.755,86.837,42.376,124.839,43.9,36.43,1.454,83.239-6.814,107.712-36.641,23.973-29.2,21.5-73.808-11.3-95.6-45.54-30.235-137.165,6.11-175.338,36.529-2.072,1.651-21.3,20.81-35.115,34.957,6.182-9.688,12.385-19.79,18.495-28.939,22.868-34.438,45.928-64.554,66.566-91.073,11.852-14.976,22.868-28.288,33.313-40.64,19.192-.335,96.531-2.683,130.344-18.554,32.99-15.5,70.736-44.4,78.714-82.154,7.807-36.97-14.937-75.419-54.083-79.628-54.34-5.86-118.926,68.612-138.776,113.2-1.71,3.861-21.625,67.2-20.625,67.191,0,0,.934-.007,1.157-.013-10.293,11.674-21.178,24.315-32.8,38.371-21.264,26.117-45.04,55.813-68.737,89.882-23.776,33.99-48.644,71.578-71.276,113.54-22.737,42.034-44.494,87.409-60.884,137.059-.184.559-.3,1.171-.493,1.736.289-16.015-.421-60.811-.868-64.238-6.274-48.4-46.842-138.25-100.6-148.188-38.719-7.149-71.512,23.184-74.6,60.844-3.144,38.456,24.736,76.938,51.926,101.227,30.662,27.393,115.776,53.912,122.55,56.01-15.173,47.427-26.88,97.327-35.957,148.47-5.216,29.248-9.563,58.865-13.542,88.613-.2-13.858-.48-26.242-.717-27.966-6.281-48.407-46.842-138.23-100.6-148.174-38.719-7.162-71.512,23.184-74.59,60.831-3.157,38.462,24.729,76.945,51.913,101.234,27.591,24.638,99.7,48.716,118.861,54.826-1.408,11.431-2.94,22.829-4.3,34.26-6.564,54.853-12.858,109.62-20.691,163.15-2.743,18.863-6.15,37.338-9.484,55.833-.2-12.3-.46-22.658-.664-24.223-6.274-48.414-46.842-138.25-100.576-148.187-38.739-7.149-71.532,23.177-74.617,60.844-3.157,38.443,24.743,76.945,51.926,101.221,26.321,23.52,92.684,46.335,115.42,53.708-3.986,18.85-7.945,37.719-12.661,55.806-3.506,12.273-6.018,24.322-10.214,36.457q-5.85,18.133-11.589,35.93c-8.221,22.573-16.548,45.908-25.111,67.717-5.841,15.219-11.694,29.616-17.535,44.125,2.953-18.745,7.971-55.563,8.044-58.687.743-32.418-10.767-85.127-33.687-122.182a76,76,0,0,0-.888-14.3c-6-37.3-41.041-65.014-79.1-54.872-52.82,14.055-86.317,106.778-88.81,155.508-.151,2.881,1.73,34.253,3.242,54.031-2.664-11.49-5.1-22.671-7.991-34.464-5.538-23.362-11.76-46.506-18.343-71.447q-5.406-17.9-10.938-36.141c-3.394-12.141-8.517-24.532-12.766-36.943-10.444-28.558-22.421-57-35.115-85.376,20.448-4.9,92.8-23.342,121.84-45.638,28.926-22.191,59.595-58.5,59.325-97.077-.27-37.785-30.7-70.486-69.855-66.231-54.34,5.9-101.5,92.467-111.369,140.269-.6,2.986-3.828,38.074-5.229,57.385-7.761-16.989-15.43-34-23.848-50.946-24.283-48.913-50.38-97.669-76.215-146.418-7.918-14.93-15.634-29.893-23.407-44.849,7.294-1.67,93.762-21.737,126.306-46.7,28.919-22.191,59.594-58.5,59.318-97.084-.27-37.779-30.708-70.48-69.855-66.218-54.34,5.9-101.5,92.46-111.363,140.262-.737,3.6-5.295,54.1-5.834,67-17.113-32.944-33.858-65.935-49.058-99.129-21.02-45.77-39.114-91.842-53.346-137.77,3.407-.77,93.736-21.31,127.069-46.875,28.926-22.191,59.6-58.5,59.319-97.084-.263-37.779-30.7-70.473-69.862-66.218-54.333,5.893-101.49,92.467-111.349,140.262-.776,3.756-5.65,58.1-5.827,68-.842-2.729-2.019-5.465-2.828-8.2-14.562-49.242-22.5-98.754-27.65-145.484-3.052-27.137-4.44-53.254-5.229-78.688,17.219-2.1,95.8-12.569,128.331-32.267,31.2-18.883,65.672-51.6,69.631-89.974,3.88-37.581-22.79-73.433-62.16-73.5-54.662-.105-111.04,80.76-126.1,127.187-.816,2.526-6.3,29.11-10.01,48.532-.178-11.484-.585-23.335-.533-34.345.079-41.33,2.683-79.175,5.275-112.672,1.625-19.047,3.473-36.226,5.374-52.274,15.818-10.885,79.03-55.5,98.471-87.4,18.975-31.129,34.5-76.044,20.33-111.935C617.152,218.406,576.966,198.886,542,216.96c-48.558,25.1-61.331,122.846-53.307,170.99.7,4.15,19.047,67.967,19.876,67.421,0,0,.77-.533.954-.658-2.144,15.41-4.249,31.971-6.189,50.1-3.328,33.5-6.774,71.394-7.741,112.888-1.079,41.462-1.092,86.547,3.19,134.027,4.229,47.592,11.1,97.452,24.829,147.9.158.565.395,1.144.552,1.71-8.6-13.509-33.911-50.472-36.174-53.1-31.938-36.91-115.335-89.454-165.643-68.092-36.246,15.4-46.868,58.786-28.663,91.9C312.273,905.859,356.76,922.572,392.829,927.834Z",
    transform: "translate(-276.867 -210.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137779",
    "data-name": "Path 137779",
    d: "M556.283,486.7c.848.533,17.449-63.765,18.034-67.934,6.728-48.341-8.682-145.708-57.9-169.484-35.457-17.127-75.1,3.473-88.007,38.982-13.2,36.253,3.532,80.746,23.342,111.343C475.01,435.545,556.224,486.655,556.283,486.7Z",
    transform: "translate(496.954 -25.762)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66668",
    "data-name": "Group 66668",
    transform: "translate(0 1010.546)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137780",
    "data-name": "Path 137780",
    d: "M40.79,439.387c14.548,6.353,50.143,5.558,50.17,5.558.368-.013-7.649-23.3-8.327-24.717-7.807-16.337-32.5-43.31-52.6-40.594C15.56,381.588,7.5,396.077,10.772,409.7,14.113,423.628,28.392,433.974,40.79,439.387Z",
    transform: "translate(-10.049 -276.206)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137781",
    "data-name": "Path 137781",
    d: "M50.523,630.03c15.1,2.2,46.861-7.011,49.387-7.761a424.982,424.982,0,0,0,19.264,53.307c4.367,10.122,9.089,20.172,13.943,30.2-2.9-4.249-5.525-8.017-5.946-8.511C115.326,683.567,84.381,664.073,65.722,672c-13.45,5.709-17.39,21.81-10.635,34.1,6.886,12.542,23.4,18.751,36.779,20.7,13.588,1.979,40.824-5.334,48.006-7.36,1.907,3.821,3.762,7.662,5.683,11.477,9.195,18.317,18.449,36.555,26.986,54.721,3.012,6.4,5.735,12.812,8.491,19.225-2.572-3.775-4.775-6.919-5.163-7.373-11.845-13.687-42.79-33.188-61.456-25.256-13.443,5.709-17.383,21.81-10.629,34.089,6.893,12.542,23.4,18.751,36.785,20.7,12.957,1.888,38.16-4.63,46.7-7,2.624,6.649,5.262,13.3,7.5,19.863,1.427,4.512,3.124,8.754,4.3,13.371q1.9,6.807,3.762,13.49c2.085,8.662,4.282,17.594,6.1,26.091,1.3,5.906,2.44,11.556,3.6,17.245-2.92-6.406-8.905-18.823-9.524-19.81-9.635-15.331-37.266-39.278-56.918-34.273-14.16,3.6-20.488,18.922-15.673,32.083,4.913,13.443,20.29,22.079,33.221,26.032,14.239,4.354,45.77.382,49.7-.145,1.888,9.418,3.637,18.6,5.15,27.288q1.7,9.649,3.118,18.554h12.628c-1.2-6.616-2.5-13.522-3.933-20.764-1.881-9.57-4.084-19.764-6.439-30.208A261.5,261.5,0,0,0,251.6,895.789c10.379,11.24,36.976,24.394,40.416,26.065-3.617,8.9-7.228,17.521-10.76,25.6-1.861,4.282-3.67,8.32-5.472,12.338h13.351c1.065-2.539,2.111-5.025,3.19-7.662,3.716-9.024,7.5-18.745,11.3-28.755,3.815.8,35.023,7.136,49.571,3.854,13.187-2.979,29.169-10.444,35.075-23.486,5.781-12.766.605-28.512-13.246-33.162-19.225-6.458-48.565,15.371-59.312,29.946-.638.855-6.478,10.951-10.056,17.376,1.532-4.1,3.058-8.057,4.584-12.3,3.071-8.359,5.88-16.8,8.945-25.861q1.983-6.639,4.012-13.417c1.434-4.453,2.387-9.339,3.617-14.048,2.611-10.977,4.722-22.224,6.6-33.6,7.327,2.664,33.49,11.766,47.046,10.813,13.49-.947,30.412-5.906,38.219-17.9,7.656-11.74,4.926-28.091-8.063-34.792-18.021-9.293-50.328,7.846-63.166,20.619-.8.8-8.978,11-13.358,16.686,1.072-6.854,2.184-13.68,3.045-20.646,2.493-20.106,4.393-40.534,6.38-60.91.605-6.242,1.283-12.45,1.94-18.672,2.6.98,33.458,12.47,48.637,11.4,13.49-.947,30.419-5.906,38.226-17.9,7.649-11.74,4.92-28.091-8.063-34.786-18.021-9.293-50.328,7.84-63.159,20.612-.967.96-12.72,15.654-15.522,19.541,1.447-13.7,3.012-27.334,5.11-40.719a422.379,422.379,0,0,1,11.687-53.55c1.2.46,33.365,12.595,48.914,11.5,13.49-.947,30.412-5.906,38.226-17.9,7.649-11.74,4.92-28.091-8.063-34.786-18.028-9.293-50.334,7.84-63.166,20.613-1.006,1-13.641,16.817-15.726,19.85.3-1.02.5-2.1.809-3.118,5.571-18.212,13.246-35.161,21.218-50.67,4.611-9.024,9.524-17.4,14.483-25.427,5.761,2.874,32.221,15.719,46.316,16.285,13.516.539,30.886-2.526,39.962-13.595,8.892-10.833,7.978-27.38-4.19-35.463-16.9-11.22-50.893,2.262-65.054,13.549-.763.612-7.9,7.722-13.023,12.97,2.289-3.591,4.591-7.34,6.86-10.734,8.484-12.779,17.035-23.954,24.7-33.793,4.393-5.551,8.484-10.49,12.358-15.074,7.116-.125,35.812-.993,48.354-6.886,12.24-5.748,26.242-16.469,29.2-30.478,2.9-13.713-5.538-27.979-20.067-29.538-20.159-2.177-44.119,25.453-51.485,41.995-.631,1.434-8.017,24.933-7.649,24.927h.427c-3.815,4.328-7.853,9.017-12.168,14.233-7.886,9.688-16.706,20.7-25.5,33.346A427.885,427.885,0,0,0,381.671,562.4c-8.432,15.594-16.508,32.425-22.586,50.847-.066.21-.112.434-.184.645.105-5.939-.158-22.559-.322-23.835-2.328-17.955-17.377-51.288-37.318-54.971-14.364-2.657-26.532,8.6-27.676,22.566-1.171,14.272,9.175,28.551,19.264,37.562,11.372,10.161,42.948,20,45.467,20.777a424.62,424.62,0,0,0-13.345,55.083c-1.934,10.852-3.545,21.836-5.025,32.879-.072-5.143-.178-9.74-.263-10.379-2.328-17.962-17.377-51.281-37.318-54.971-14.371-2.657-26.538,8.6-27.676,22.566-1.171,14.272,9.175,28.544,19.258,37.562,10.234,9.135,36.989,18.074,44.1,20.336-.526,4.242-1.092,8.471-1.6,12.713-2.433,20.35-4.768,40.666-7.675,60.529-1.019,7-2.282,13.851-3.519,20.711-.072-4.564-.171-8.406-.243-8.984-2.328-17.962-17.383-51.294-37.318-54.978-14.371-2.651-26.538,8.6-27.683,22.573-1.171,14.259,9.182,28.544,19.264,37.555,9.767,8.721,34.391,17.186,42.823,19.922-1.48,6.992-2.947,14-4.7,20.7-1.3,4.551-2.236,9.024-3.788,13.529-1.447,4.479-2.881,8.932-4.3,13.325-3.052,8.373-6.143,17.035-9.313,25.124-2.17,5.65-4.341,10.99-6.5,16.37,1.092-6.952,2.953-20.613,2.979-21.77.276-12.03-3.992-31.583-12.5-45.329a28.711,28.711,0,0,0-.329-5.308c-2.223-13.838-15.226-24.118-29.347-20.356-19.593,5.216-32.024,39.614-32.951,57.694-.053,1.065.645,12.707,1.21,20.047-.993-4.269-1.9-8.412-2.966-12.792-2.059-8.662-4.367-17.251-6.807-26.505q-2-6.63-4.058-13.4c-1.256-4.505-3.164-9.1-4.735-13.707-3.874-10.6-8.32-21.152-13.029-31.675,7.59-1.822,34.424-8.662,45.2-16.936,10.734-8.228,22.112-21.7,22.007-36.01-.1-14.022-11.391-26.15-25.914-24.572-20.159,2.184-37.66,34.3-41.317,52.038-.23,1.105-1.421,14.128-1.94,21.29-2.881-6.307-5.729-12.615-8.853-18.9-9-18.146-18.685-36.233-28.275-54.32-2.933-5.538-5.794-11.089-8.682-16.64,2.71-.618,34.786-8.063,46.861-17.324,10.727-8.234,22.105-21.7,22.007-36.022-.105-14.009-11.391-26.144-25.92-24.565-20.159,2.19-37.654,34.306-41.31,52.038-.276,1.335-1.967,20.073-2.164,24.861-6.353-12.227-12.562-24.46-18.205-36.779a424.314,424.314,0,0,1-19.79-51.11c1.263-.289,34.779-7.906,47.144-17.4,10.727-8.228,22.112-21.7,22.007-36.016-.1-14.016-11.391-26.144-25.92-24.565-20.159,2.184-37.654,34.306-41.31,52.037-.289,1.395-2.1,21.553-2.164,25.23-.309-1.013-.75-2.032-1.046-3.045-5.4-18.264-8.346-36.634-10.26-53.971-1.131-10.07-1.644-19.758-1.94-29.2,6.386-.776,35.542-4.663,47.611-11.97,11.576-7,24.361-19.146,25.835-33.379,1.44-13.943-8.458-27.242-23.059-27.268-20.284-.04-41.2,29.965-46.783,47.184-.3.94-2.335,10.8-3.716,18.008-.066-4.262-.217-8.655-.2-12.74.026-15.338.993-29.38,1.96-41.8.6-7.064,1.289-13.437,1.993-19.4,5.867-4.038,29.32-20.593,36.529-32.418,7.044-11.55,12.8-28.216,7.544-41.528-5.15-13.042-20.053-20.284-33.03-13.582-18.015,9.313-22.757,45.579-19.777,63.442.263,1.539,7.064,25.217,7.373,25.013l.355-.244c-.8,5.716-1.578,11.859-2.3,18.587-1.236,12.431-2.512,26.486-2.874,41.883a426.587,426.587,0,0,0,1.184,49.722c1.572,17.653,4.117,36.154,9.214,54.866.053.21.145.427.2.638-3.19-5.012-12.582-18.725-13.424-19.7-11.845-13.694-42.79-33.188-61.449-25.262-13.45,5.709-17.39,21.809-10.635,34.1C20.643,621.874,37.145,628.077,50.523,630.03Z",
    transform: "translate(-7.502 -363.747)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137782",
    "data-name": "Path 137782",
    d: "M111.17,466.364c.316.2,6.472-23.657,6.689-25.2,2.493-17.929-3.223-54.057-21.481-62.877-13.154-6.353-27.86,1.289-32.648,14.463-4.9,13.45,1.309,29.958,8.655,41.311C81.015,447.389,111.144,466.351,111.17,466.364Z",
    transform: "translate(279.585 -295.357)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(416.885 253.468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66672",
    "data-name": "Group 66672",
    transform: "translate(915.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137783",
    "data-name": "Path 137783",
    d: "M206.912,142.139s42.218,40.758,58.233,50.952S387.426,209.1,387.426,209.1s227.106,214,240.207,228.559,13.1,17.469,27.656,14.555,286.792-88.8,286.792-88.8L867.827,219.886,678.585,328.473,430.459,168.94l-37.206-16.614Z",
    transform: "translate(-206.912 303.487)",
    fill: "#ffdcb4",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137784",
    "data-name": "Path 137784",
    d: "M404.145,165.566s-63.679,68.474-45.658,99.715,61.272,39.646,61.272,39.646-8.405,16.818,0,31.234,19.225,18.021,19.225,18.021S459.406,396.23,449.8,455.1s-32.438,54.063-33.642,100.918-58.391,74.9-90.829,153-19.547,187.893-6.485,208.624c29.741,47.184,52.991,58.812,52.991,58.812s-35.181,73.841-15.746,128.608c50.63,142.7,242.733,207.618,391.709,177.587s201.9-144.741,184.96-194.4c-18.3-53.656,14.338-61.838,35.963-84.66s80.852-56.635,73.643-139.532S966.4,700.188,976.007,658.141s35.575-147.267,4.341-204.934S864.276,361.392,825.833,308.532,778.978,154.754,718.91,111.5,587.954,67.049,515.87,86.273,404.145,165.566,404.145,165.566Z",
    transform: "translate(339.785 -74.384)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137785",
    "data-name": "Path 137785",
    d: "M482.517,344.8s-31.859,518.114-31.859,529.847-20.3,162.65-18.449,256.538c1.8,90.823,8.623,319.158,8.386,325.288,0,0-6.708,33.536-33.536,46.947s-100.932,51.044-114.342,57.747-1.677,26.828,1.677,33.536,35.878,12.174,82.832,10.5,80.5-14,80.5-14,92.6,4.808,102.668-18.666-22.546-104.325-20.869-114.388,40.245-271.632,51.978-328.642,25.151-212.945,25.151-212.945L739.055,509.122s229.71,471.16,238.1,482.9S1190.1,1389.408,1190.1,1389.408s51.979,142.518,55.333,179.409,53.649,83.838,85.508,85.508,46.947-53.649,40.245-92.217-57.01-115.7-65.4-125.753-46.947-176.061-46.947-207.914-13.411-130.785-50.3-186.117-100.6-105.634-114.02-144.2-20.119-283.366-28.505-378.937-41.915-233.071-82.16-271.632l-497.988,21.8Z",
    transform: "translate(236.592 891.386)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137786",
    "data-name": "Path 137786",
    d: "M1155.515,1339.929c-10.628-46.552-20.185-95.63-20.185-111.487,0-31.86-13.411-130.785-50.3-186.117s-100.6-105.634-114.02-144.2S950.89,614.756,942.5,519.185s-41.915-233.071-82.16-271.632l-497.988,21.8L359.008,344.8s-31.859,518.114-31.859,529.847-20.3,162.644-18.449,256.538c1.046,52.866,3.795,152.279,5.86,227.388l115.868,4.052c12.713-83.91,30.287-197.785,37.562-233.117,11.74-57,25.151-212.945,25.151-212.945L615.546,509.122s229.71,471.16,238.1,482.9c7.083,9.918,154.219,286.772,199.679,372.386Z",
    transform: "translate(360.101 891.386)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_66669",
    "data-name": "Group 66669",
    transform: "translate(682.04 955.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137787",
    "data-name": "Path 137787",
    d: "M364.037,288.039,310.612,515.42s33.543,3.729,63.363,16.153,54.728,16.3,75.794,13.667c39.765-4.972,47.217,4.972,119.281,6.215s104.371-26.1,130.462-33.55,69.585-16.153,84.5-23.6,19.876-36.036,37.272-45.974,45.974-22.369,53.432-27.341a36.194,36.194,0,0,0,11.181-12.424L745.487,219.7,365.28,268.163Z",
    transform: "translate(-310.612 -219.703)",
    fill: "#302d8b",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137788",
    "data-name": "Path 137788",
    d: "M335.132,240.327c-.48,10.346-.434,19.12.638,23.395",
    transform: "translate(-175.488 -104.682)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137789",
    "data-name": "Path 137789",
    d: "M339.195,231.038s-2.342,18.771-4.078,38.9",
    transform: "translate(-173.946 -156.487)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137790",
    "data-name": "Path 137790",
    d: "M372.576,224.048s36.036,69.579,50.946,114.309",
    transform: "translate(34.964 -195.471)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137791",
    "data-name": "Path 137791",
    d: "M360.863,226.5s18.639,33.55,21.125,48.46",
    transform: "translate(-30.359 -181.774)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137792",
    "data-name": "Path 137792",
    d: "M337.96,231.416s-9.938,48.46-12.424,58.4",
    transform: "translate(-227.38 -154.379)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66670",
    "data-name": "Group 66670",
    transform: "translate(660.915 360.604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137793",
    "data-name": "Path 137793",
    d: "M522.358,190.1s11.181,39.758,6.209,48.46-11.181,13.667-26.091,13.667-42.244-21.125-90.7-12.431S307.4,291.981,307.4,291.981L353.374,406.29s-17.4,106.857-4.972,178.922,11.181,141.65,11.181,162.769,0,45.974,14.91,53.432,186.38-2.486,264.661-27.334,125.49-19.882,135.435-53.432,8.695-144.13,13.667-177.679,29.821-193.832,8.7-234.834-49.7-60.884-78.28-68.342-42.244-7.452-42.244-7.452-24.848-72.065-23.6-103.128c0,0-55.911,53.425-73.308,60.884S522.358,190.1,522.358,190.1Z",
    transform: "translate(-307.4 -129.212)",
    fill: "#302d8b",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15821",
    "data-name": "Line 15821",
    y1: 23.516,
    x2: 5.1,
    transform: "translate(63.238 173.951)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15822",
    "data-name": "Line 15822",
    y1: 59.71,
    x2: 12.95,
    transform: "translate(45.973 217.37)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15823",
    "data-name": "Line 15823",
    x1: 22.365,
    y1: 80.764,
    transform: "translate(24.85 187.619)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137794",
    "data-name": "Path 137794",
    d: "M337.779,149.426s-4.972,60.884-1.243,84.489",
    transform: "translate(-152.641 -16.478)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137795",
    "data-name": "Path 137795",
    d: "M325.158,224.8s13.667,32.307,32.307,39.758",
    transform: "translate(-208.363 403.91)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137796",
    "data-name": "Path 137796",
    d: "M385.175,222.348s-14.91,27.334-27.334,32.306",
    transform: "translate(-26.088 390.212)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_137797",
    "data-name": "Path 137797",
    d: "M506.877,232.34s-24.848-72.065-23.6-103.128c0,0-55.911,53.425-73.308,60.884s-57.155,0-57.155,0,11.181,39.758,6.209,48.46c-4.387,7.675-9.767,12.437-21.218,13.45-.007,30.333,1.559,107.311,17.488,113.283C372.2,371.629,487.041,265.653,521,233.826A112.026,112.026,0,0,0,506.877,232.34Z",
    transform: "translate(523.063 231.392)",
    fill: "#ffdcb4",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_66671",
    "data-name": "Group 66671",
    transform: "translate(767.956 128.421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137798",
    "data-name": "Path 137798",
    d: "M323.675,173.2s19.218,75.689,19.218,99.715,34.845,75.689,56.471,93.71,54.063,56.471,79.293,50.459,91.3-67.277,104.522-96.11,10.813-66.08,10.813-66.08,25.229-18.021,30.031-40.843-12.01-46.855-12.01-46.855-37.246,15.614-87.705,9.609-98.518-38.443-111.731-54.063S387.347,93.91,387.347,93.91Z",
    transform: "translate(-323.675 -93.91)",
    fill: "#ffdcb4",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137799",
    "data-name": "Path 137799",
    d: "M348.411,126.823c.927,7.721-2.012,14.43-6.557,14.976s-8.978-5.281-9.905-13.009,2.012-14.437,6.564-14.976S347.49,119.1,348.411,126.823Z",
    transform: "translate(-278.477 16.898)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137800",
    "data-name": "Path 137800",
    d: "M346.064,126.823c-.921,7.721,2.013,14.43,6.557,14.976s8.984-5.281,9.905-13.009-2.013-14.437-6.557-14.976S346.992,119.1,346.064,126.823Z",
    transform: "translate(-199.751 16.898)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137801",
    "data-name": "Path 137801",
    d: "M342.509,119.077s33.99-26.532,70.46,3.315",
    transform: "translate(-218.637 -14.16)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137802",
    "data-name": "Path 137802",
    d: "M379.878,118.325s-29.011-25.7-53.879,6.63",
    transform: "translate(-310.714 -11.751)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137803",
    "data-name": "Path 137803",
    d: "M338.98,124.734s13.266,15.745,28.189,4.144",
    transform: "translate(-238.318 77.997)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137804",
    "data-name": "Path 137804",
    d: "M336.964,150.809s17.409,19.06,55.537,10.773,51.393-36.47,51.393-36.47",
    transform: "translate(-249.561 80.105)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137805",
    "data-name": "Path 137805",
    d: "M342,140.873s9.951,26.525,23.21,26.525,24.868-38.127,24.868-38.127S363.558,141.7,342,140.873Z",
    transform: "translate(-221.447 103.3)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_137806",
    "data-name": "Path 137806",
    d: "M489.219,480.319a146.231,146.231,0,0,0-15.167-40.83c-11.661-21-33.457-.566-33.457-.566s-6.708,33.536-33.536,46.947-100.932,51.044-114.342,57.747-1.677,26.828,1.677,33.536,35.878,12.174,82.832,10.5,80.5-14,80.5-14,92.6,4.808,102.668-18.666c7.189-16.778-7.406-62.837-15.713-91.441C514.942,481.9,489.219,480.319,489.219,480.319Z",
    transform: "translate(236.592 1908.938)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137807",
    "data-name": "Path 137807",
    d: "M457.448,429.024c-18.666,9.333-25.67,51.334-25.67,51.334l-3.256.71c11.872,36.365,22.987,73.656,24.48,90.066,3.348,36.884,53.656,83.838,85.508,85.508s46.947-53.649,40.245-92.217-57.01-115.7-65.4-125.753C513.359,438.673,476.114,419.691,457.448,429.024Z",
    transform: "translate(1029.018 1889.068)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137808",
    "data-name": "Path 137808",
    d: "M348.449,207.332c8.668,7.314,16.462,13.628,22.29,17.9",
    transform: "translate(582.447 667.072)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137809",
    "data-name": "Path 137809",
    d: "M336.7,196.877s32.622,30.11,62.37,55.971",
    transform: "translate(516.911 608.764)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137810",
    "data-name": "Path 137810",
    d: "M338.941,202.484s38.726,40.567,60.851,59.009",
    transform: "translate(529.421 640.034)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66675",
    "data-name": "Group 66675",
    transform: "translate(0 13.018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66673",
    "data-name": "Group 66673",
    transform: "translate(395.607)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137811",
    "data-name": "Path 137811",
    d: "M536.036,98.7s-95.742,1.453-208.887,30.465-124.754,58.029-124.754,58.029l124.754,21.757L549.091,113.2Z",
    transform: "translate(287.986 48.18)",
    fill: "#92e3a9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137812",
    "data-name": "Path 137812",
    d: "M221.363,208.732s66.724-78.333,184.23-105.9,105.9,92.842,105.9,92.842Z",
    transform: "translate(393.771 48.394)",
    fill: "#ffc13e",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137813",
    "data-name": "Path 137813",
    d: "M221.363,208.732s66.724-78.333,184.23-105.9,105.9,92.842,105.9,92.842Z",
    transform: "translate(393.771 48.394)",
    fill: "#ffad00",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137814",
    "data-name": "Path 137814",
    d: "M221.363,208.732s66.724-78.333,184.23-105.9,105.9,92.842,105.9,92.842Z",
    transform: "translate(393.771 48.394)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137815",
    "data-name": "Path 137815",
    d: "M463.787,85.241S381.1,89.6,296.967,117.153s-89.941,95.742-89.941,95.742l94.3,71.085S489.9,121.507,488.451,107,463.787,85.241,463.787,85.241Z",
    transform: "translate(313.813 -26.854)",
    fill: "#ffad00",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137816",
    "data-name": "Path 137816",
    d: "M424.257,78.175s-143.61-7.248-187.13,7.254-39.166,98.643-31.912,132.008S337.223,333.489,337.223,333.489L443.12,99.938Z",
    transform: "translate(277.911 -76.364)",
    fill: "#ffad00",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137817",
    "data-name": "Path 137817",
    d: "M419.677,84.09s-153.765-14.5-224.843,0S173.07,150.82,173.07,150.82L489.308,255.264Z",
    transform: "translate(31.531 -69.223)",
    fill: "#ffad00",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137818",
    "data-name": "Path 137818",
    d: "M441.841,87.01S199.581,78.3,161.868,105.866s-43.52,84.14,17.4,101.543c0,0,248.06-1.447,314.791,20.31S688.447,274.14,688.447,274.14Z",
    transform: "translate(-96.523 -24.269)",
    fill: "#ffad00",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137819",
    "data-name": "Path 137819",
    d: "M457.191,106.284S190.5,86.007,140.953,133.848c-25.92,25.032-10.155,81.233,18.863,87.041l319.138-20.31Z",
    transform: "translate(-127.836 66.702)",
    fill: "#ffad00",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137820",
    "data-name": "Path 137820",
    d: "M504.29,187.033s-213.248-89.941-285.779-84.14-44.967,95.742-30.458,98.643S504.29,187.033,504.29,187.033Z",
    transform: "translate(110.844 70.093)",
    fill: "#ffc13e",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137821",
    "data-name": "Path 137821",
    d: "M504.29,187.033s-213.248-89.941-285.779-84.14-44.967,95.742-30.458,98.643S504.29,187.033,504.29,187.033Z",
    transform: "translate(110.844 70.093)",
    fill: "#ffad00",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137822",
    "data-name": "Path 137822",
    d: "M504.29,187.033s-213.248-89.941-285.779-84.14-44.967,95.742-30.458,98.643S504.29,187.033,504.29,187.033Z",
    transform: "translate(110.844 70.093)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137823",
    "data-name": "Path 137823",
    d: "M492.563,281.24s-94.1-102.3-182.783-166.827c-94.5-68.75-148.734,3.492-134.909,36.272,19.935,47.25,87.041,52.222,87.041,52.222Z",
    transform: "translate(122.572 -24.114)",
    fill: "#ffc13e",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137824",
    "data-name": "Path 137824",
    d: "M492.563,281.24s-94.1-102.3-182.783-166.827c-94.5-68.75-148.734,3.492-134.909,36.272,19.935,47.25,87.041,52.222,87.041,52.222Z",
    transform: "translate(122.572 -24.114)",
    fill: "#ffad00",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137825",
    "data-name": "Path 137825",
    d: "M492.563,281.24s-94.1-102.3-182.783-166.827c-94.5-68.75-148.734,3.492-134.909,36.272,19.935,47.25,87.041,52.222,87.041,52.222Z",
    transform: "translate(122.572 -24.114)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137826",
    "data-name": "Path 137826",
    d: "M221.363,285.268S272.131,119.9,373.674,89.43c55.477-16.64,110.238,16.864,105.9,47.874C470.469,202.391,242.765,251.62,221.363,285.268Z",
    transform: "translate(393.771 -28.143)",
    fill: "#ffbd32",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137827",
    "data-name": "Path 137827",
    d: "M221.363,285.268S272.131,119.9,373.674,89.43c55.477-16.64,110.238,16.864,105.9,47.874C470.469,202.391,242.765,251.62,221.363,285.268Z",
    transform: "translate(393.771 -28.143)",
    fill: "#ffad00",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137828",
    "data-name": "Path 137828",
    d: "M221.363,285.268S272.131,119.9,373.674,89.43c55.477-16.64,110.238,16.864,105.9,47.874C470.469,202.391,242.765,251.62,221.363,285.268Z",
    transform: "translate(393.771 -28.143)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137829",
    "data-name": "Path 137829",
    d: "M395.73,320.891S337.7,161.319,298.535,112s-94.289-36.266-105.9-10.155,20.31,52.222,20.31,52.222Z",
    transform: "translate(219.404 -63.765)",
    fill: "#ffc64d",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137830",
    "data-name": "Path 137830",
    d: "M395.73,320.891S337.7,161.319,298.535,112s-94.289-36.266-105.9-10.155,20.31,52.222,20.31,52.222Z",
    transform: "translate(219.404 -63.765)",
    fill: "#ffad00",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137831",
    "data-name": "Path 137831",
    d: "M395.73,320.891S337.7,161.319,298.535,112s-94.289-36.266-105.9-10.155,20.31,52.222,20.31,52.222Z",
    transform: "translate(219.404 -63.765)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137832",
    "data-name": "Path 137832",
    d: "M221.363,332.791s10.155-216.142,58.023-245.16,76.886,4.354,66.731,34.819S237.319,261.706,221.363,332.791Z",
    transform: "translate(393.771 -75.665)",
    fill: "#ffbd32",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137833",
    "data-name": "Path 137833",
    d: "M221.363,332.791s10.155-216.142,58.023-245.16,76.886,4.354,66.731,34.819S237.319,261.706,221.363,332.791Z",
    transform: "translate(393.771 -75.665)",
    fill: "#ffad00",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137834",
    "data-name": "Path 137834",
    d: "M221.363,332.791s10.155-216.142,58.023-245.16,76.886,4.354,66.731,34.819S237.319,261.706,221.363,332.791Z",
    transform: "translate(393.771 -75.665)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66674",
    "data-name": "Group 66674",
    transform: "translate(0 232.843)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20698",
    "data-name": "Rectangle 20698",
    width: 1529.345,
    height: 206.908,
    transform: "matrix(0.999, -0.049, 0.049, 0.999, 0, 75.128)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20699",
    "data-name": "Rectangle 20699",
    width: 969.317,
    height: 206.907,
    transform: "translate(559.352 47.617) rotate(-2.816)",
    fill: "#dbdbdb",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137835",
    "data-name": "Path 137835",
    d: "M334.072,158.642,303,212.373l26.646,56.06-60.7-12.95-45.082,42.665-6.443-61.735-54.507-29.691,56.722-25.2L231.024,120.5l41.5,46.158Z",
    transform: "translate(463.371 -63.041)",
    fill: "#ffad00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137836",
    "data-name": "Path 137836",
    d: "M378.172,173.969l-36.056,20.825L338.83,236.3l-30.948-27.856-40.492,9.7,16.929-38.04-21.74-35.512,41.41,4.345,27.055-31.649,8.664,40.726Z",
    transform: "translate(1019.252 -80.954)",
    fill: "#ffad00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137837",
    "data-name": "Path 137837",
    d: "M334.072,158.642,303,212.373l26.646,56.06-60.7-12.95-45.082,42.665-6.443-61.735-54.507-29.691,56.722-25.2L231.024,120.5l41.5,46.158Z",
    transform: "translate(463.371 -63.041)",
    fill: "#ffad00",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137838",
    "data-name": "Path 137838",
    d: "M378.172,173.969l-36.056,20.825L338.83,236.3l-30.948-27.856-40.492,9.7,16.929-38.04-21.74-35.512,41.41,4.345,27.055-31.649,8.664,40.726Z",
    transform: "translate(1019.252 -80.954)",
    fill: "#ffad00",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137839",
    "data-name": "Path 137839",
    d: "M189.95,186.962l-36.056,20.825-3.285,41.508-30.948-27.856-40.492,9.7L96.1,193.1l-21.74-35.512,41.41,4.345,27.056-31.65,8.664,40.726Z",
    transform: "translate(-30.469 -8.49)",
    fill: "#ffad00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20700",
    "data-name": "Rectangle 20700",
    width: 200.243,
    height: 206.907,
    transform: "translate(182.06 66.173) rotate(-2.816)",
    fill: "#ffad00",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20701",
    "data-name": "Rectangle 20701",
    width: 971.085,
    height: 206.907,
    transform: "translate(557.586 47.704) rotate(-2.816)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20702",
    "data-name": "Rectangle 20702",
    width: 199.763,
    height: 206.907,
    transform: "translate(942.782 28.758) rotate(-2.816)",
    fill: "#ffad00",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20703",
    "data-name": "Rectangle 20703",
    width: 199.763,
    height: 206.907,
    transform: "translate(942.782 28.758) rotate(-2.816)",
    fill: "#ffad00",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20704",
    "data-name": "Rectangle 20704",
    width: 199.763,
    height: 206.907,
    transform: "translate(942.782 28.758) rotate(-2.816)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_66676",
    "data-name": "Group 66676",
    transform: "translate(1139.243 421.71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137840",
    "data-name": "Path 137840",
    d: "M1037.356,288.626c-9.938-27.334-94.433-23.612-94.433-23.612L757.792,364.42S504.318,205.374,490.645,191.707s-37.272-43.487-53.425-47.217-43.487-4.966-64.613-2.486-44.731-9.938-50.939,1.243,12.424,21.126,21.119,23.612,49.7,11.181,49.7,11.181L325.4,194.193s-84.5-9.938-84.5-4.972,13.667,23.612,23.612,27.341,83.246,31.057,95.67,33.543,82.01-12.424,82.01-12.424,187.617,197.561,214.951,216.2,59.641,45.974,74.551,45.974c10.806,0,189.774-57.365,287.634-88.994C1027.839,378.442,1045.123,309.995,1037.356,288.626Z",
    transform: "translate(-240.901 -138.503)",
    fill: "#ffdcb4",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137841",
    "data-name": "Path 137841",
    d: "M572.535,335.153s24.848-86.975,9.938-131.705S496.4,143.057,466.131,145.293s-89.915,46.973-98.61,58.154S347.639,228.3,347.639,228.3l76.406,145.846,105-16.62",
    transform: "translate(354.382 -101.784)",
    fill: "#302d8b",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15824",
    "data-name": "Line 15824",
    x2: 68.339,
    y2: 33.548,
    transform: "translate(796.454 270.645)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137842",
    "data-name": "Path 137842",
    d: "M361.241,192.1l75.793-38.518,11.183,17.4-75.794,42.245",
    transform: "translate(430.243 -54.404)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gift",
    transform: "translate(332.161 1320.233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66678",
    "data-name": "Group 66678"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20705",
    "data-name": "Rectangle 20705",
    width: 1529.345,
    height: 1432.437,
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20706",
    "data-name": "Rectangle 20706",
    width: 971.31,
    height: 1432.437,
    transform: "translate(558.035)",
    fill: "#dbdbdb",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_66677",
    "data-name": "Group 66677",
    transform: "translate(41.746 54.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137843",
    "data-name": "Path 137843",
    d: "M326.826,358.87l-45.4,58.056,22.09,70.309L234.279,462l-60.041,42.736,2.6-73.651-59.2-43.9,70.85-20.286,23.455-69.865,41.187,61.114Z",
    transform: "translate(253.891 46.299)",
    fill: "#ffad00",
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137844",
    "data-name": "Path 137844",
    d: "M372.365,467.083l-57.453,50.295,8.861,75.841-65.587-39.1-69.391,31.863,16.918-74.459-51.747-56.148,76.043-6.92,37.41-66.565L297.5,452.074Z",
    transform: "translate(456.479 519.52)",
    fill: "#92e3a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137845",
    "data-name": "Path 137845",
    d: "M432.748,381.828l-32.191,57.025L429.282,497.7,365.1,484.705l-47.09,45.5-7.475-65.056-57.829-30.723,59.562-27.213,11.35-64.492L367.9,390.963Z",
    transform: "translate(1007.158 301.096)",
    fill: "#92e3a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137846",
    "data-name": "Path 137846",
    d: "M352.859,259.142l-2.434,45.08,35.757,27.562L342.555,343.4l-15.163,42.524-24.529-37.9-45.128-1.281L286.2,311.7l-12.727-43.316L315.6,284.631Z",
    transform: "translate(1035.199 -165.057)",
    fill: "#92e3a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137847",
    "data-name": "Path 137847",
    d: "M264.329,268.557l-19.991,37.291,19.386,37.609-41.643-7.489L192.3,366.027l-5.746-41.92-37.79-19.031,38.092-18.419,6.422-41.821,29.288,30.536Z",
    transform: "translate(427.49 -244.837)",
    fill: "#92e3a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137848",
    "data-name": "Path 137848",
    d: "M177.025,455.182l-33.109,21.825-.791,39.647-30.988-24.743-37.952,11.5,13.957-37.118L65.48,433.752l39.614,1.8,23.944-31.61,10.526,38.233Z",
    transform: "translate(-37.012 642.523)",
    fill: "#ffad00",
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137849",
    "data-name": "Path 137849",
    d: "M201.164,297.389l-24.43,44.967,23.193,45.617-50.315-9.339-36.218,36.154-6.667-50.739L61.151,340.778l46.195-22.019,8.05-50.538,35.217,37.13Z",
    transform: "translate(-61.151 -114.424)",
    fill: "#ffad00",
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137850",
    "data-name": "Path 137850",
    d: "M398.23,476.748l-39.839,47.086,16.2,59.513L317.5,560.008l-51.592,33.8,4.553-61.511-48.089-38.622L282.28,479l21.872-57.671,32.471,52.44Z",
    transform: "translate(837.989 739.466)",
    fill: "#92e3a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137851",
    "data-name": "Path 137851",
    d: "M230.218,472.631l-28.727,25.147,4.43,37.921-32.793-19.55-34.7,15.932,8.459-37.229-25.874-28.075,38.022-3.459,18.705-33.283,15.039,35.092Z",
    transform: "translate(272.728 788.023)",
    fill: "#ffad00",
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137852",
    "data-name": "Path 137852",
    d: "M356.04,441.629l-23.2,19.677,3.058,30.266-25.883-15.983-27.839,12.26,7.2-29.554-20.263-22.689,30.334-2.283,15.316-26.282,11.545,28.144Z",
    transform: "translate(1098.678 659.779)",
    fill: "#92e3a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137853",
    "data-name": "Path 137853",
    d: "M202.463,306.956l-62.523-.608V421.03l39.218,14.291-22.09-70.308Z",
    transform: "translate(378.255 98.213)",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137854",
    "data-name": "Path 137854",
    d: "M372.365,467.083l-57.453,50.295,8.861,75.841-65.587-39.1-69.391,31.863,16.918-74.459-51.747-56.148,76.043-6.92,37.41-66.565L297.5,452.074Z",
    transform: "translate(456.479 519.52)",
    fill: "#ffad00",
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137855",
    "data-name": "Path 137855",
    d: "M432.748,381.828l-32.191,57.025L429.282,497.7,365.1,484.705l-47.09,45.5-7.475-65.056-57.829-30.723,59.562-27.213,11.35-64.492L367.9,390.963Z",
    transform: "translate(1007.158 301.096)",
    fill: "#ffad00",
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137856",
    "data-name": "Path 137856",
    d: "M352.859,259.142l-2.434,45.08,35.757,27.562L342.555,343.4l-15.163,42.524-24.529-37.9-45.128-1.281L286.2,311.7l-12.727-43.316L315.6,284.631Z",
    transform: "translate(1035.199 -165.057)",
    fill: "#ffad00",
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137857",
    "data-name": "Path 137857",
    d: "M264.329,268.557l-19.991,37.291,19.386,37.609-41.643-7.489L192.3,366.027l-5.746-41.92-37.79-19.031,38.092-18.419,6.422-41.821,29.288,30.536Z",
    transform: "translate(427.49 -244.837)",
    fill: "#ffad00",
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137858",
    "data-name": "Path 137858",
    d: "M398.23,476.748l-39.839,47.086,16.2,59.513L317.5,560.008l-51.592,33.8,4.553-61.511-48.089-38.622L282.28,479l21.872-57.671,32.471,52.44Z",
    transform: "translate(837.989 739.466)",
    fill: "#ffad00",
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137859",
    "data-name": "Path 137859",
    d: "M356.04,441.629l-23.2,19.677,3.058,30.266-25.883-15.983-27.839,12.26,7.2-29.554-20.263-22.689,30.334-2.283,15.316-26.282,11.545,28.144Z",
    transform: "translate(1098.678 659.779)",
    fill: "#ffad00",
    opacity: 0.93
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20707",
    "data-name": "Rectangle 20707",
    width: 971.085,
    height: 1432.437,
    transform: "translate(558.26)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137860",
    "data-name": "Path 137860",
    d: "M367.224,303.307l-31.075,53.731L362.795,413.1l-60.7-12.95-45.082,42.665-6.443-61.735-54.508-29.691,56.722-25.2,11.394-61.015,41.5,46.157Z",
    transform: "translate(732.978 -77.141)",
    fill: "#92e3a9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137861",
    "data-name": "Path 137861",
    d: "M321.356,354.227l-18.9,39.5,21.82,37.962-43.4-5.772L251.508,458.4l-7.923-43.064-39.967-17.887L242.126,376.6l4.661-43.537,31.723,30.182Z",
    transform: "translate(775.141 301.532)",
    fill: "#92e3a9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20708",
    "data-name": "Rectangle 20708",
    width: 214.511,
    height: 1432.437,
    transform: "translate(170.857)",
    fill: "#ffad00",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20709",
    "data-name": "Rectangle 20709",
    width: 253.53,
    height: 1432.437,
    transform: "translate(917.038)",
    fill: "#ffad00",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20710",
    "data-name": "Rectangle 20710",
    width: 253.53,
    height: 1432.437,
    transform: "translate(917.038)",
    fill: "#ffad00",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20711",
    "data-name": "Rectangle 20711",
    width: 253.53,
    height: 1432.437,
    transform: "translate(917.038)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Sparkles",
    transform: "translate(567.129 503.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137862",
    "data-name": "Path 137862",
    d: "M336.049,112.354s15.239,14.463,17.258,47.94",
    transform: "translate(1278.744 -112.354)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_66685",
    "data-name": "Group 66685",
    transform: "translate(0 331.481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66679",
    "data-name": "Group 66679",
    transform: "translate(403.888 224.131)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3135",
    "data-name": "Ellipse 3135",
    cx: 55.382,
    cy: 55.382,
    r: 55.382,
    transform: "translate(0 25.448) rotate(-13.282)",
    fill: "#ffad00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3136",
    "data-name": "Ellipse 3136",
    cx: 55.382,
    cy: 55.382,
    r: 55.382,
    transform: "translate(0 25.448) rotate(-13.282)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66680",
    "data-name": "Group 66680",
    transform: "translate(156.68 9.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137863",
    "data-name": "Path 137863",
    d: "M188.2,201.081c-26.512-5.755-31.175-10.418-36.924-36.924-5.755,26.505-10.411,31.169-36.924,36.924,26.512,5.748,31.169,10.411,36.924,36.917C157.024,211.492,161.687,206.829,188.2,201.081Z",
    transform: "translate(-114.352 -164.157)",
    fill: "#ffad00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137864",
    "data-name": "Path 137864",
    d: "M188.2,201.081c-26.512-5.755-31.175-10.418-36.924-36.924-5.755,26.505-10.411,31.169-36.924,36.924,26.512,5.748,31.169,10.411,36.924,36.917C157.024,211.492,161.687,206.829,188.2,201.081Z",
    transform: "translate(-114.352 -164.157)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66681",
    "data-name": "Group 66681",
    transform: "translate(853.571 383.056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137865",
    "data-name": "Path 137865",
    d: "M294.151,257.919c-26.505-5.755-31.169-10.418-36.924-36.924-5.748,26.505-10.411,31.169-36.917,36.924,26.505,5.748,31.169,10.411,36.917,36.917C262.982,268.33,267.645,263.667,294.151,257.919Z",
    transform: "translate(-220.31 -220.995)",
    fill: "#ffad00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137866",
    "data-name": "Path 137866",
    d: "M294.151,257.919c-26.505-5.755-31.169-10.418-36.924-36.924-5.748,26.505-10.411,31.169-36.917,36.924,26.505,5.748,31.169,10.411,36.917,36.917C262.982,268.33,267.645,263.667,294.151,257.919Z",
    transform: "translate(-220.31 -220.995)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66682",
    "data-name": "Group 66682",
    transform: "translate(1028.949 166.145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137867",
    "data-name": "Path 137867",
    d: "M320.815,224.938c-26.512-5.755-31.169-10.418-36.924-36.924-5.748,26.505-10.411,31.169-36.917,36.924,26.506,5.748,31.169,10.411,36.917,36.917C289.647,235.35,294.3,230.687,320.815,224.938Z",
    transform: "translate(-246.975 -188.015)",
    fill: "#ffad00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137868",
    "data-name": "Path 137868",
    d: "M320.815,224.938c-26.512-5.755-31.169-10.418-36.924-36.924-5.748,26.505-10.411,31.169-36.917,36.924,26.506,5.748,31.169,10.411,36.917,36.917C289.647,235.35,294.3,230.687,320.815,224.938Z",
    transform: "translate(-246.975 -188.015)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66683",
    "data-name": "Group 66683",
    transform: "translate(0 318.679)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3137",
    "data-name": "Ellipse 3137",
    cx: 55.382,
    cy: 55.382,
    r: 55.382,
    transform: "translate(0 74.323) rotate(-42.145)",
    fill: "#ffad00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3138",
    "data-name": "Ellipse 3138",
    cx: 55.382,
    cy: 55.382,
    r: 55.382,
    transform: "translate(0 74.323) rotate(-42.145)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66684",
    "data-name": "Group 66684",
    transform: "translate(692.039)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3139",
    "data-name": "Ellipse 3139",
    cx: 55.382,
    cy: 55.382,
    r: 55.382,
    fill: "#ffad00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3140",
    "data-name": "Ellipse 3140",
    cx: 55.382,
    cy: 55.382,
    r: 55.382,
    fill: "none"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotData);
export default __webpack_public_path__ + "static/media/notData.88493ab7693cca65bc5c7309e88a86b6.svg";
export { ForwardRef as ReactComponent };